import { render, staticRenderFns } from "./task-details.vue?vue&type=template&id=f3657c3a&scoped=true&"
import script from "./task-details.vue?vue&type=script&lang=js&"
export * from "./task-details.vue?vue&type=script&lang=js&"
import style0 from "./task-details.vue?vue&type=style&index=0&id=f3657c3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3657c3a",
  null
  
)

export default component.exports